// extracted by mini-css-extract-plugin
export default {"error":"Error_error__fs8fM","error_container":"Error_error_container__rVkFS","error_link":"Error_error_link__DT02B"};